goog.provide("shadow.js.shim.module$src$svg$divider$vertical_components_svg$default");
shadow.js.shim.module$src$svg$divider$vertical_components_svg$default = shadow.js.shim.module$src$svg$divider$vertical_components_svg.default;
